document.addEventListener("DOMContentLoaded", () => {
	setTimeout(() => {
		const productMedia = document.querySelector(".js-product-filtered-media");
		if (!productMedia) return;

		const productMediaSwiperEl = productMedia.querySelector(".js-product-media-swiper");
		const productMediaThumbsSwiperEl = productMedia.querySelector(".js-product-swiper-thumbs");
		if (!productMediaSwiperEl || !productMediaThumbsSwiperEl) return;

		const featuredMediaThumbsSwiper = new Swiper(productMediaThumbsSwiperEl, {
			freeMode: false,
			draggable: true,
			// Horizontal is the base because breakpoints only apply upwards:
			// Swiper falls back to these below 990, where op-pdp.css hides the
			// strip anyway. It stays initialised there because global.js reads
			// and filters its slides when the flavour changes.
			direction: 'horizontal',
			slidesPerView: 5.25,
			spaceBetween: 10,
			centeredSlides: false,
			mousewheel: false,
			a11y: true,
			keyboard: {
				enabled: true,
				onlyInViewport: true,
			},
			grabCursor: true,
			breakpoints: {
				// The vertical rail down the left of the image, matching the
				// 990 two-column break in op-pdp.css. Swiper handles a
				// direction change across a breakpoint itself (changeDirection
				// in setBreakpoint), so this does not need a re-init.
				//
				// 'auto' so the number of visible tiles follows the rail's
				// height - the rail stretches to the square frame beside it,
				// which is sized off the viewport, so a fixed count would
				// leave a gap on a tall screen and overflow on a short one.
				// The tiles get their height from aspect-ratio in op-pdp.css.
				990: {
					direction: 'vertical',
					slidesPerView: 'auto',
					spaceBetween: 8,
					autoHeight: false,
				}
			}
		});

		const productMediaSwiper = new Swiper(productMediaSwiperEl, {
			freeMode: false,
			draggable: true,
			// 'auto' so Swiper reads each slide's CSS width rather than dividing
			// the frame itself. op-pdp.css sets slides to 100%: one image fills
			// the frame, and the rail beside it says what else there is.
			slidesPerView: 'auto',
			centeredSlides: false,
			a11y: true,
			autoHeight: true,
			keyboard: {
				enabled: true,
				onlyInViewport: true,
			},
			pagination: {
				el: productMedia.querySelector('.op-gallery__dots'),
				clickable: true,
			},
			navigation: {
				nextEl: productMediaSwiperEl.querySelector('.op-gallery__nav--next'),
				prevEl: productMediaSwiperEl.querySelector('.op-gallery__nav--prev'),
			},
			thumbs: {
				swiper: featuredMediaThumbsSwiper,
			},
			grabCursor: true,
			loop: false
		});

		// The rail chevrons step the gallery, not the strip.
		//
		// They started as the thumb swiper's own navigation, which scrolled
		// the column of tiles and left the photo where it was - so reaching a
		// tile below the fold took a scroll and then a click, and the arrows
		// did nothing visible in the part of the page you were looking at.
		// Driving the main swiper instead does both jobs at once: the photo
		// changes, and Swiper's thumbs module scrolls the rail to keep the
		// active tile in view, which is the scrolling they used to do.
		const railPrev = productMedia.querySelector('.op-rail__nav--prev');
		const railNext = productMedia.querySelector('.op-rail__nav--next');

		if (railPrev && railNext) {
			railPrev.addEventListener('click', () => productMediaSwiper.slidePrev());
			railNext.addEventListener('click', () => productMediaSwiper.slideNext());

			// Same class Swiper's own navigation sets, so op-pdp.css keeps one
			// rule for a spent arrow. The ends are now the gallery's ends, not
			// the strip's: on a product with a single image both are set and
			// neither chevron is drawn.
			const syncRailNav = () => {
				railPrev.classList.toggle('swiper-button-disabled', productMediaSwiper.isBeginning);
				railNext.classList.toggle('swiper-button-disabled', productMediaSwiper.isEnd);
			};

			// `update` matters as much as `slideChange`: the variant filter in
			// global.js adds and removes slides when the flavour changes, which
			// moves where the ends are without the active slide moving.
			productMediaSwiper.on('slideChange', syncRailNav);
			productMediaSwiper.on('fromEdge', syncRailNav);
			productMediaSwiper.on('toEdge', syncRailNav);
			productMediaSwiper.on('update', syncRailNav);
			syncRailNav();
		}

		// Hold the rail as a skeleton until its thumbnails are actually there.
		//
		// The markup ships with .is-loading so the placeholder is up from the
		// first paint, before this script runs at all; everything below is
		// about deciding when to take it off.
		//
		// Only the tiles the shopper can currently get to: the variant filter
		// marks the rest .hidden, and a tile for another flavour is never
		// going to load while this one is selected.
		const thumbImages = Array.from(
			productMediaThumbsSwiperEl.querySelectorAll('.product-media__thumb-swiper-slide:not(.hidden) img')
		);

		// Start them, on desktop only.
		//
		// The tiles are marked loading="lazy" in the snippet, and the browser
		// took that literally: clipped inside the rail's overflow they are not
		// urgent, so at two and a half seconds one of thirteen had arrived and
		// the skeleton was timing out over a rail that was still empty. Lazy
		// is the wrong hint for something sitting at the top of the page.
		//
		// Flipping the attribute is what kicks the fetch off. Only above 990,
		// because below it the rail is display:none and these are bytes the
		// phone would download for a strip it never draws - the markup keeps
		// lazy so that stays true with the script off as well.
		//
		// Priority as well as eagerness. Eager alone only got them into the
		// queue: this page asks for 48 images, several of them full-size
		// photography, and the rail's thirteen 6KB tiles were being served
		// last - first byte at 1.3s, last one done at nearly twenty. They are
		// 80KB all together and they are on screen at the top of the page, so
		// they go to the front.
		if (window.matchMedia('(min-width: 990px)').matches) {
			thumbImages.forEach((img) => {
				img.loading = 'eager';
				img.fetchPriority = 'high';
			});
		}

		const settled = thumbImages.map((img) => (
			img.complete
				? Promise.resolve()
				: new Promise((resolve) => {
					img.addEventListener('load', resolve, { once: true });
					// A broken image resolves too. One 404 in the set should
					// cost that tile its picture, not leave the whole rail
					// shimmering behind it.
					img.addEventListener('error', resolve, { once: true });
				})
		));

		// A ceiling on the wait. Whatever is holding an image up - a slow
		// connection, a lazy tile the browser has decided not to fetch yet -
		// a rail of real thumbnails with one gap in it beats a rail that
		// never stops pretending to load.
		const ceiling = new Promise((resolve) => setTimeout(resolve, 2500));

		Promise.race([Promise.all(settled), ceiling]).then(() => {
			productMediaThumbsSwiperEl.classList.remove('is-loading');
			// The tiles were already at their full size under the skeleton, so
			// nothing reflows - but the thumbs swiper measured itself while
			// they were still decoding, so let it check its numbers.
			featuredMediaThumbsSwiper.update();
		});
	}, 100);
});